// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const container = "TooltipIcon__container__LgyMT";
export const danger = "TooltipIcon__danger__GRUxn";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const iconWrapper = "TooltipIcon__iconWrapper__fiO0q";
export const incorrect = "TooltipIcon__incorrect__uG27v";
export const medium = "500";
export const message = "TooltipIcon__message__iVTBY";
export const onBottom = "TooltipIcon__onBottom__F6khh";
export const outerWrapper = "TooltipIcon__outerWrapper__WGvEX";
export const regular = "400";
export const sans = "'sans'";
export const secure = "TooltipIcon__secure__RB+5c";
export const semibold = "600";
export const serif = "'serif'";
export const textCenter = "TooltipIcon__textCenter__GBNBT";
export const tooltipContainer = "TooltipIcon__tooltipContainer__I-QL9";
export const tooltipIcon = "TooltipIcon__tooltipIcon__IhZkk";
export const tooltipIconWrapper = "TooltipIcon__tooltipIconWrapper__oUGNC";
export const tooltipOpened = "TooltipIcon__tooltipOpened__s8OGU";
export const transparent = "TooltipIcon__transparent__R3awV";
export const warning = "TooltipIcon__warning__j74X-";
export const wide = "TooltipIcon__wide__kPKSl";